import React from 'react';
import {LeftNavigationAndTopNavigationLayout} from './LeftNavigationAndTopNavigationLayout';

type FullscreenLayoutProps = {
    children: any
}

export const FullscreenLayout = (props: FullscreenLayoutProps) => (
    <>    
        {props.children}
    </>
)